<template>
  <Modal title="评测报告" v-model="visible">
    <Form ref="insertUserForm" class="form" :label-width="80"
          :model="reportParam" :rules="ruleUser" >
      <Row>
        <Col :span="22" >
        <Form-item label="老师：" :label-width="90">
          <Select v-model="reportParam.tchId"   transfer>
            <Option v-for="item in tchAll"
                    :value="item.id" :key="item.id">{{ item.tchName }}</Option>
          </Select>
        </Form-item>
        </Col>
        <Col :span="22" >
        <Form-item label="外教运营：" :label-width="90">
         <!-- <AdminUserSelect adminGroupCode="tchStudyAdviser" transfer
                           v-model="reportParam.studyAdviserId"></AdminUserSelect>-->
          <Select v-model="reportParam.studyAdviserId"   transfer>
            <Option v-for="item in studyAll"
                    :value="item.id" :key="item.id">{{ item.nickname }}</Option>
          </Select>
        </Form-item>
        </Col>
        <Col :span="22">
        <Form-item label="学导：" :label-width="90">
          <!--<AdminUserSelect adminGroupCode="userStudyAdviser" transfer
                           v-model="reportParam.tutorId"></AdminUserSelect>-->
          <Select v-model="reportParam.tutorId"  transfer>
            <Option v-for="item in tutorAll"
                    :value="item.id" :key="item.id">{{ item.nickname }}</Option>
          </Select>
        </Form-item>
        </Col>
        <Col :span="22">
          <Form-item :label-width="90" label="测评报告：">
            <file-upload @on-file-change="handleReportDoc" :defaultFileList="defaultAudioList"
                         text="点击上传测评报告(PDF格式)" accept="application/*" ></file-upload>
          </Form-item>
        </Col>
        <Col :span="11">
        <Form-item label="对应课节：" :label-width="90" prop="lessonNum">
          <Input  v-model.number="reportParam.lessonNum"></Input>
        </Form-item>
        </Col>

      </Row>
    </Form>
    <div slot="footer">
      <Button type="text" size="large" @click="visible=false">取消</Button>
      <Button type="primary" size="large" @click="insert">保存</Button>
    </div>
  </Modal>
</template>
<script>
  import SingleOnePicUpload from '../common/SingleOnePicUpload.vue'
  import FileUpload from '../common/FileUpload.vue'
  export default {
    components: {
      SingleOnePicUpload, FileUpload
    },
    props: {
      value: {
        type: Boolean,
        default: false
      },
      uid: {
        type: Number
      },
      successCallback: {
        type: Function
      }
    },
    data () {
      return {
        visible: this.value,
        tchAll: [],
        studyAll: [],
        tutorAll: [],
        defaultAudioList: [],
        reportDocUrl: '',
        uploadText: '点击上传测评报告(PDF格式)',
        reportParam: {
          tchId: '',
          tutorId: '',
          studyAdviserId: '',
          lessonNum: '',
          reportDoc: '',
          uid: '',
          tchName: '',
          studyName: '',
          tutorName: '',
        },
        ruleUser: {
          lessonNum: [
            { type: 'integer', required: true, message: '请选择状态', trigger: 'blur' }
          ]
        },
      }
    },
    methods: {
      handleReportDoc (file) {
        file.forEach(f => {
          this.reportParam.reportDoc = f.name
          this.reportDocUrl = f.url
        })
      },
      insert () {
        let self = this
        // 老师
        self.tchAll.forEach(element => {
          if (element.id === self.reportParam.tchId) {
            self.reportParam.tchName = element.tchName
          }
        })
        // 外管
        self.studyAll.forEach(element => {
          if (element.id === self.reportParam.studyAdviserId) {
            self.reportParam.studyName = element.nickname
          }
        })
        // 学导
        self.tutorAll.forEach(element => {
          if (element.id === self.reportParam.tutorId) {
            self.reportParam.tutorName = element.nickname
          }
        })
        // 保存
        self.$refs.insertUserForm.validate((valid) => {
          if (!valid) {
            self.$Message.warning('信息输入错误!')
            return
          }
          if (self.reportParam.uid) {
            self.$http.post('/stageReport/insert', {
              uid: self.reportParam.uid,
              tchId: self.reportParam.tchId,
              tchName: self.reportParam.tchName,
              studyAdviserId: self.reportParam.studyAdviserId,
              studyName: self.reportParam.studyName,
              tutorId: self.reportParam.tutorId,
              tutorName: self.reportParam.tutorName,
              lessonNum: self.reportParam.lessonNum,
              reportDoc: self.reportParam.reportDoc
            }).then(function (res) {
              if (res && res.data > 0) {
                self.visible = false
                self.successCallback()
              }
            })
          }
        })
      }
    },
    watch: {
      value (val) {
        if (val) {
          let self = this
          self.reportParam.lessonNum = ''
          self.reportParam.reportDoc = ''
          self.reportParam.studyAdviserId = ''
          self.reportParam.tutorId = ''
          self.reportParam.tchId = ''
          self.reportParam.tchName = ''
          self.reportParam.studyName = ''
          self.reportParam.tutorName = ''
          self.defaultAudioList = []
          if (self.reportParam.uid) {
            self.$http.get('/tchList/selectAllId?id=' + self.reportParam.uid).then(function (res) {
              if (res && res.data) {
                if (res.data.tchId === 0) {
                  self.reportParam.tchId = ''
                } else {
                  self.reportParam.tchId = res.data.tchId
                }
                self.reportParam.tutorId = res.data.tutorId
                self.reportParam.studyAdviserId = res.data.studyAdviserId
              } else {
                self.reportParam.tchId = ''
                self.reportParam.tutorId = ''
                self.reportParam.studyAdviserId = ''
              }
            })
          }
          let params = { status: 1, adminGroupId: 4 }
          let para = { status: 1, adminGroupId: 7 }
          self.$http.get('/adminUser/listByCondition', { params: params }).then(function (res) {
            if (res && res.data) {
              self.tutorAll = res.data
            } else {
              self.tutorAll = []
            }
          })
          self.$http.get('/adminUser/listByCondition', { params: para }).then(function (res) {
            if (res && res.data) {
              self.studyAll = res.data
            } else {
              self.studyAll = []
            }
          })
          self.$http.get('/tchList/selectAllTch').then(function (res) {
            if (res && res.data) {
              self.tchAll = res.data
            } else {
              self.tchAll = []
            }
          })
        }
        this.visible = val
      },
      visible (val) {
        if (val === true) {

        }
        this.$emit('input', val)
      },
      uid (val) {
        let self = this
        self.reportParam.uid = val
      }
    }
  }
</script>




// WEBPACK FOOTER //
// StageReportModal.vue?043a444a